/* eslint-disable */

export enum SalesIndexType {
  NOT_USED = 0,
  GLOBAL = 1,
  COUNTRY = 2,
  STORE = 3,
  UNRECOGNIZED = -1,
}

export interface SalesIndex {
  marketAreaNo: string;
  retailUnitCode: string;
  week: number;
  year: number;
  type: SalesIndexType;
  ytdIndex: number;
  goalIndex: number;
  notificationHigh?: boolean | undefined;
  lastUpdated: string;
  /** one-to-many relation */
  salesIndexWeek: SalesIndexWeek[];
  ytdIndexMonth: YtdIndexMonth[];
  name: string;
}

export interface YtdIndexMonth {
  marketAreaNo: string;
  retailUnitCode: string;
  month: number;
  year: number;
  type: SalesIndexType;
  ytdIndex: number;
  lastUpdated: string;
  /** many-to-one relation */
  salesIndex: SalesIndex | undefined;
}

export interface SalesIndexWeek {
  marketAreaNo: string;
  retailUnitCode: string;
  week: number;
  year: number;
  type: SalesIndexType;
  weekIndex: number;
  performanceDeviationWeek?: number | undefined;
  lastUpdated: string;
  /** many-to-one relation */
  salesIndex: SalesIndex | undefined;
}

export interface SalesIndexGoal {
  id: string;
  type: SalesIndexType;
  goalIndex: number;
  retailUnitCode: string;
  marketAreaNo: string;
}

export interface FinancialIndexGoal {
  id: string;
  type: SalesIndexType;
  goalIndex: number;
}

export interface SalesIndexList {
  items: SalesIndex[];
  count: number;
}

export interface SalesIndexRequest {
  unitName: string;
}

export interface SalesIndexImportRequest {
}
